export default __webpack_public_path__ + "static/media/staggeringblow3.8c297279.png";